/* 3D/AR preview on the PDP via <model-viewer> (Google's custom element -
 * handles glTF rendering + WebXR "Enter AR" on Android, hands off to iOS AR
 * Quick Look when given both src and ios-src).
 *
 * Vendored (not CDN) at public/js/vendor/model-viewer.min.js and lazy-loaded
 * from its raw asset path only when a model is actually attached, same
 * pattern rfhq_templates.js already uses for Swiper - keeps the ~900KB
 * payload off every PDP that doesn't need it.
 *
 * Data comes from raftor_webhq.catalog.ar.get_ar_model_urls (item + Website
 * Item's enable_ar_preview/ar_model_gltf/ar_model_usdz fields). Gated on
 * window.rfhqArPreviewEnabled, the global switch from Raftor Storefront
 * Feature Settings.
 */

import { isPdp, getPdpItemCode, getPdpMainBlock } from './pdp_context.js';

let modelViewerReady = null;

function ensureModelViewer() {
	if (window.customElements && window.customElements.get('model-viewer')) return Promise.resolve();
	if (modelViewerReady) return modelViewerReady;
	modelViewerReady = new Promise(function (resolve) {
		var script = document.createElement('script');
		script.type = 'module';
		script.src = '/assets/raftor_websitehq/js/vendor/model-viewer.min.js';
		script.onload = resolve;
		script.onerror = resolve;
		document.head.appendChild(script);
	});
	return modelViewerReady;
}

frappe.ready(function () {
	if (!window.rfhqArPreviewEnabled) return;
	if (!isPdp()) return;

	var itemCode = getPdpItemCode();
	if (!itemCode) return;

	frappe.call({
		method: 'raftor_webhq.catalog.ar.get_ar_model_urls',
		args: { item_code: itemCode },
		callback: function (r) {
			var data = r && r.message;
			if (!data || !data.enabled || !data.gltf) return;

			var anchor = getPdpMainBlock();
			if (!anchor) return;

			var trigger = document.createElement('button');
			trigger.type = 'button';
			trigger.className = 'rfhq-pdp-ar-trigger';
			trigger.textContent = __('View in 3D / AR');

			var viewer = document.createElement('model-viewer');
			viewer.className = 'rfhq-pdp-ar-viewer';
			viewer.setAttribute('src', data.gltf);
			if (data.usdz) viewer.setAttribute('ios-src', data.usdz);
			viewer.setAttribute('camera-controls', '');
			viewer.setAttribute('ar', '');
			viewer.setAttribute('ar-modes', 'webxr scene-viewer quick-look');
			viewer.style.display = 'none';

			trigger.addEventListener('click', function () {
				var opening = viewer.style.display === 'none';
				if (opening) {
					ensureModelViewer().then(function () {
						viewer.style.display = '';
					});
				} else {
					viewer.style.display = 'none';
				}
			});

			anchor.appendChild(trigger);
			anchor.appendChild(viewer);
		},
	});
});
